import React, { useEffect, useState } from 'react';
import { StreamChat } from 'stream-chat';
import { Chat } from 'stream-chat-react';
import { Auth } from 'aws-amplify';
import LoadingCircleIcon from '../../../icons/LoadingCircle';
import { useLocation } from 'react-router-dom';

import 'stream-chat-react/dist/css/v2/index.css';
import './App.css';

import { ChannelContainer } from './_components/ChannelContainer/ChannelContainer.jsx';
import { ChannelListContainer } from './_components/ChannelListContainer/ChannelListContainer.jsx';

import { getStreamToken } from '../../../services/apiService';
import { ChatDraftProvider } from './_contexts/ChatContext';

const apiKey = process.env.REACT_APP_STREAM_API_KEY || 'f32mgp7mcnqn';

const filters = [{ type: 'messaging' }, { type: 'messaging' }];
const options = { state: true, watch: true, presence: true, limit: 3 };
const sort = { last_message_at: -1, updated_at: -1 };

const ChatHome = () => {
  const location = useLocation();
  const [createType, setCreateType] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [chatClient, setChatClient] = useState(null);
  const [me, setMe] = useState(null);
  const [initialChannel, setInitialChannel] = useState(null);

  // async function to get the stream token and get connected user from aws-amplify,
  // and then use the cognito user and retrived stream token to connect to stream chat
  const InitailizeStreamChat = async () => {
    const _chatClient = StreamChat.getInstance(apiKey, {
      enableInsights: true,
      enableWSFallback: true,
    });
    const _streamToken = await getStreamToken();
    const _cognitoUserSessionDetails = await Auth.currentAuthenticatedUser();
    if (_chatClient && !_chatClient.user) {
      await _chatClient.connectUser(
        { id: _cognitoUserSessionDetails.attributes['custom:userId'] },
        _streamToken.data.token
      );
    }
    const _jobGroupId = location?.pathname?.split('/')[3];
    if (_jobGroupId && _chatClient) {
      // get channel with channel id as _jobGroupId
      const [existingChannel] = await _chatClient.queryChannels({
        type: 'messaging',
        room_type: 'group',
        id: _jobGroupId,
      });
      // set the channel to active channel
      existingChannel?.watch();
      setInitialChannel(existingChannel);
    }
    setMe(_cognitoUserSessionDetails.attributes['custom:userId']);
    setChatClient(_chatClient);
  };

  useEffect(() => {
    InitailizeStreamChat();
    if (!('Notification' in window)) {
      console.log('Browser does not support desktop notification');
    } else {
      Notification.requestPermission();
    }
    return () => {
      if (chatClient) {
        chatClient.disconnectUser();
      }
    };
  }, []);

  if (!chatClient || !chatClient.user) {
    return (
      <LoadingCircleIcon iconStyle='w-10 h-10 absolute m-auto left-12 right-0 top-1/2 z-50' />
    );
  }

  return (
    <ChatDraftProvider>
      <div className='app__wrapper'>
        <Chat client={chatClient} theme='light'>
          <ChannelListContainer
            {...{
              isCreating,
              filters,
              options,
              setCreateType,
              setIsCreating,
              setIsEditing,
              sort,
              me,
            }}
            initialChannel={initialChannel}
          />
          <ChannelContainer
            {...{
              createType,
              isCreating,
              isEditing,
              setIsCreating,
              setIsEditing,
            }}
            initialChannel={initialChannel}
          />
        </Chat>
      </div>
    </ChatDraftProvider>
  );
};

export default ChatHome;
